import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { Button } from '@udemy-v2/react-core-components';
import { StarRating, StarRatingProps } from '@udemy-v2/react-merchandising-components';
import classNames from 'classnames';
import React from 'react';
import styles from './review-summary-widget.module.scss';
import { useI18n } from '@udemy-v2/i18n';
interface ReviewSummaryRatingGaugeProps {
  rating: number;
  percent: number;
  size: StarRatingProps['size'];
  selectedRating?: number;
  onRatingSelected?: (rating: number | undefined) => void;
  ariaLabel: string;
}
export const ReviewSummaryRatingGauge = t0 => {
  const $ = _c(38);
  const {
    rating,
    percent,
    size,
    selectedRating,
    onRatingSelected,
    ariaLabel
  } = t0;
  const {
    gettext,
    interpolate
  } = useI18n();
  let t1;
  if ($[0] !== onRatingSelected || $[1] !== percent || $[2] !== rating || $[3] !== selectedRating) {
    t1 = () => {
      if (percent > 0) {
        const newRating = selectedRating === rating ? undefined : rating;
        onRatingSelected?.(newRating);
      }
    };
    $[0] = onRatingSelected;
    $[1] = percent;
    $[2] = rating;
    $[3] = selectedRating;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleRatingSelected = t1;
  let percentLabel;
  let roundedPercent;
  if ($[5] !== gettext || $[6] !== interpolate || $[7] !== percent) {
    roundedPercent = Math.round(percent);
    if (percent > 0 && roundedPercent === 0) {
      let t2;
      if ($[10] !== gettext) {
        t2 = gettext("< 1%");
        $[10] = gettext;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      percentLabel = t2;
    } else {
      percentLabel = interpolate(gettext("%(percent)s%"), {
        percent: roundedPercent
      }, true);
    }
    $[5] = gettext;
    $[6] = interpolate;
    $[7] = percent;
    $[8] = percentLabel;
    $[9] = roundedPercent;
  } else {
    percentLabel = $[8];
    roundedPercent = $[9];
  }
  const isRatingSelected = selectedRating === rating;
  const isDisabled = percent <= 0;
  const isInactive = !!selectedRating && !isRatingSelected;
  let t2;
  if ($[12] !== isDisabled || $[13] !== isInactive) {
    t2 = classNames(styles["rates-row"], {
      [styles.disabled]: isDisabled,
      [styles.inactive]: isInactive
    });
    $[12] = isDisabled;
    $[13] = isInactive;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const gaugeStyle = t2;
  const t3 = `rate-gauge-${rating}`;
  const t4 = `${roundedPercent}%`;
  let t5;
  if ($[15] !== t4) {
    t5 = <span className={styles["rate-gauge"]}><span className={styles["rate-gauge--bg"]}><span className={styles["rate-gauge--fill"]} style={{
          width: t4
        }} /></span></span>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== ariaLabel || $[18] !== rating || $[19] !== size) {
    t6 = <StarRating aria-label={ariaLabel} rating={rating} size={size} />;
    $[17] = ariaLabel;
    $[18] = rating;
    $[19] = size;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = classNames(styles["rate-percent"], "ud-text-sm");
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== percentLabel) {
    t8 = <span className={t7}><span data-purpose="percent-label">{percentLabel}</span></span>;
    $[22] = percentLabel;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== isRatingSelected) {
    t9 = isRatingSelected ? <Icon glyph="close" label={false} size="xsmall" /> : null;
    $[24] = isRatingSelected;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t9) {
    t10 = <span className={styles["rate-clear"]}>{t9}</span>;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== gaugeStyle || $[29] !== handleRatingSelected || $[30] !== isDisabled || $[31] !== isRatingSelected || $[32] !== t10 || $[33] !== t3 || $[34] !== t5 || $[35] !== t6 || $[36] !== t8) {
    t11 = <Button udStyle="link" size="small" typography="ud-heading-xs" data-purpose={t3} disabled={isDisabled} onClick={handleRatingSelected} className={gaugeStyle} aria-pressed={isRatingSelected}>{t5}{t6}{t8}{t10}</Button>;
    $[28] = gaugeStyle;
    $[29] = handleRatingSelected;
    $[30] = isDisabled;
    $[31] = isRatingSelected;
    $[32] = t10;
    $[33] = t3;
    $[34] = t5;
    $[35] = t6;
    $[36] = t8;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  return t11;
};